import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const MufflerSettings = lazy(() => import('../components/MufflerSettings'));

const MufflerRoute: RouteObject = {
  path: 'settings/modules/campaign/mufflers',
  element: <MufflerSettings />,
};

export default MufflerRoute;
